export default __webpack_public_path__ + "48145b87aa71dfd0d6dfd8d6a17985ef.png";